<template>
  <div>
    <div class="about-us">
      <div class="about">
        <div class="content">
          <div class="title">{{ $t('about_us') }}</div>
          <div class="desc" v-html="$t('about_us_desc')"></div>
        </div>
        <div class="img">
          <div class="img-inner">
            <img :src="require('@/assets/images/aboutUs/about-1.png')" />
          </div>
        </div>
      </div>

      <div class="who">
        <div class="who-wrapper">
          <div class="img">
            <img @click="goCTI" :src="require('@/assets/images/aboutUs/about-3.png')" />
            <img @click="goWoHui" :src="require('@/assets/images/aboutUs/about-2.png')" />
          </div>
          <div class="content">
            <div class="title">{{ $t('who_we_are') }}</div>
            <div class="desc" v-html="$t('who_we_are_desc')"></div>
          </div>
        </div>
      </div>

      <div class="why">
        <div class="title">
          {{ $t('why_choose_hsk_mock') }}
        </div>

        <div class="carousel" @mouseenter="pause" @mouseleave="autoRun">
          <div class="carousel-inner">
            <div
              class="carousel-active-inner"
              :style="{
                transition: `all ${duration / 1000}s ease-in-out`,
                transform: `translateY(-${
                  (activeKey + 1) * (isMobile ? 550 : 440) - (isMobile ? 100 : 110)
                }px)`,
              }"
            >
              <div class="carousel-item">
                <div class="content">
                  <div class="title">{{ carouselList[4].title }}</div>
                  <div class="content">{{ carouselList[4].content }}</div>
                </div>
                <div class="img">
                  <img :src="carouselList[4].img" />
                </div>
                <div class="index-bg">
                  {{ carouselList[4].key }}
                </div>
                <div class="mask-bg"></div>
              </div>
              <div
                v-for="(item, index) in carouselList"
                :key="index"
                class="carousel-item"
                :class="[activeKey === index ? 'active' : '']"
                :style="{ opacity: index + 2 === activeKey ? 0 : 1 }"
              >
                <div class="content">
                  <div class="title">{{ item.title }}</div>
                  <div class="content">{{ item.content }}</div>
                </div>
                <div class="img">
                  <img :src="item.img" />
                </div>
                <div class="index-bg">
                  {{ item.key }}
                </div>
                <transition name="fade" appear mode="in-out">
                  <div v-if="activeKey !== index" class="mask-bg"></div>
                </transition>

              </div>
            </div>
          </div>

          <div class="indicator">
            <div
              v-for="(item, index) in carouselList"
              :key="index"
              class="indicator-item"
              :class="[index === activeKey ? 'active' : '']"
              @click="goIndex(index)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data() {
    return {
      carouselList: [
        {
          key: '01',
          title: this.$t('about_us_carousel_1'),
          content: this.$t('about_us_carousel_1_content'),
          img: require('@/assets/images/aboutUs/about-4.png'),
        },
        {
          key: '02',
          title: this.$t('about_us_carousel_2'),
          content: this.$t('about_us_carousel_2_content'),
          img: require('@/assets/images/aboutUs/about-5.png'),
        },
        {
          key: '03',
          title: this.$t('about_us_carousel_3'),
          content: this.$t('about_us_carousel_3_content'),
          img: require('@/assets/images/aboutUs/about-6.png'),
        },
        {
          key: '04',
          title: this.$t('about_us_carousel_4'),
          content: this.$t('about_us_carousel_4_content'),
          img: require('@/assets/images/aboutUs/about-7.png'),
        },
        {
          key: '05',
          title: this.$t('about_us_carousel_5'),
          content: this.$t('about_us_carousel_5_content'),
          img: require('@/assets/images/aboutUs/about-8.png'),
        },
      ],
      activeKey: 0,
      opacityZeroActive: true,
      duration: 1000,
      autoRunTimer: null,
      // 判断移动
      isMobile: window.innerWidth <= 768,
    }
  },
  mounted() {
    this.autoRun()

    window.addEventListener('resize', this.handleResize)
  },
  unMounted() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768
    },
    goCTI() {
      window.open("https://www.chinesetest.cn/");
    },
    goWoHui() {
      window.open("https://www.wohuimandarin.cn/");
    },
    goBack() {
      this.$router.back()
    },

    async goIndex(index) {
      // this.opacityZeroActive = false
      this.activeKey = index

      // setTimeout(() => {
      //   this.opacityZeroActive = true
      // }, this.duration)
    },

    autoRun() {
      this.autoRunTimer = setTimeout(() => {
        this.activeKey = (this.activeKey + 1) % this.carouselList.length

        this.goIndex(this.activeKey)

        this.autoRun()
      }, 5000)
    },

    pause() {
      clearTimeout(this.autoRunTimer)
    },
  },
  computed: {
    bgCarouselList() {
      return [
        this.carouselList[this.carouselList.length - 1],
        ...this.carouselList.slice(0, this.carouselList.length - 1),
      ]
    },
  },
}
</script>

<style lang="scss">
#app{
  overflow: auto;
}
</style>

<style lang="scss" scoped>

.page-back {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 14px;
  margin-top: 34px;
  cursor: pointer;

  a {
    color: rgba(241, 169, 88, 1);
  }

  @media screen and (max-width: 768px) {
    width: 95%;
  }
}
.about-us {
  .about {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    column-gap: 150px;
    padding-top: 98px;

    & > .content {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      & > .title {
        font-size: 46px;
        font-weight: 600;
        font-family: Calibri;
        margin-bottom: 34px;
      }
      & > .desc {
        font-size: 24px;
        line-height: 32px;
        font-family: Calibri light;
      }
    }

    & > .img {
      width: 360px;
      height: 300px;
      margin-right: 34px;
      background: rgba(241, 169, 88, 1);
      border-radius: 26px;

      & > .img-inner {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        right: -34px;
        top: 67px;
        border-radius: 24px;

        & > img {
          border-radius: 24px;
          transition: all 0.3s ease;

          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }

  .who {
    margin-top: 166px;
    background: rgba(232, 237, 242, 1);

    .who-wrapper {
      width: 1200px;
      margin: 0 auto;
      padding: 75px 0px;
      display: flex;
      column-gap: 71px;

      & > .img {
        display: flex;
        column-gap: 24px;

        & > img {
          border-radius: 30px;
          transition: all 0.7s ease-in-out;
        }

        & > img:nth-of-type(1) {
          width: 295px;
          height: 295px;
        }

        & > img:nth-of-type(2) {
          width: 295px;
          height: 295px;
        }

        &:hover {
          & > img:nth-of-type(1) {
            transform: translateY(56px);
          }
          & > img:nth-of-type(2) {
            transform: translateY(-26px);
          }
        }
      }

      & > .content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;

        & > .title {
          font-size: 46px;
          line-height: 70px;
          font-weight: 600;
          font-family: Calibri;
          margin-bottom: 18px;
        }
        & > .desc {
          font-size: 21px;
          line-height: 32px;
          font-family: Calibri light;
        }
      }
    }
  }

  .why {
    width: 1200px;
    margin: 0 auto;
    padding: 67px 0px;

    & > .title {
      text-align: center;
      font-size: 36px;
      font-family: Calibri;
      font-weight: 600;
    }

    .carousel {
      position: relative;
      box-shadow: 0 0 50px 10px rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      margin-top: 93px;
      height: 550px;
      // background: rgba(0, 0, 0, 0.1);

      .carousel-active-inner {
      }

      .mask-bg {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.05);
        left: 0;
        top: 0;
        border-radius: 40px;
      }

      .carousel-inner {
        height: 550px;
        overflow: hidden;
        border-radius: 40px;

        .carousel-item {
          position: relative;
          width: 100%;
          display: flex;
          height: 440px;
          column-gap: 72px;
          padding: 49px 57px 67px 120px;
          border-radius: 40px;
          background-color: #fff;
          box-shadow: 0 0px 20px 0px rgba(0, 0, 0, 0.3);
          transform: translateY(330px);
          transition: all 1s ease-in-out;

          &.active {
            transform: translateY(0px);
            opacity: 1;
          }

          & > .mask-bg {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.05);
            left: 0;
            top: 0;
            border-radius: 40px;
          }

          & > .content {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            row-gap: 20px;

            & > .title {
              width: 70%;
              font-size: 38px;
              font-weight: 600;
              font-family: Calibri;
            }
            & > .content {
              font-family: Calibri light;
              font-size: 20px;
              line-height: 24px;
            }
          }
          & > .img {
            width: 354px;
            height: 324px;
            border-radius: 30px;
            & > img {
              width: 100%;
              height: 100%;
              border-radius: 30px;
            }
          }

          & > .index-bg {
            position: absolute;
            font-size: 400px;
            line-height: 400px;
            top: 50%;
            transform: translate(-280px, -50%);
            z-index: 0;
            font-weight: 600;
          }

          &:nth-of-type(1) {
            & > .index-bg {
              color: rgba(12, 133, 62, 0.05);
            }
          }

          &:nth-of-type(2) {
            & > .index-bg {
              color: rgba(45, 47, 71, 0.1);
            }
          }
          &:nth-of-type(3) {
            & > .index-bg {
              color: rgba(250, 175, 86, 0.12);
            }
          }
          &:nth-of-type(4) {
            & > .index-bg {
              color: rgba(217, 217, 217, 0.25);
            }
          }
          &:nth-of-type(5) {
            & > .index-bg {
              color: rgba(217, 98, 98, 0.08);
            }
          }
          &:nth-of-type(6) {
            & > .index-bg {
              color: rgba(12, 133, 62, 0.05);
            }
          }
        }
      }

      .indicator {
        position: absolute;
        top: 50%;
        right: -53px;
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        transform: translateY(-50%);

        .indicator-item {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: rgba(217, 217, 217, 1);

          &.active {
            background-color: rgba(250, 175, 86, 1);
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .about-us {
    width: 100%;
    // margin: 0 auto;
    padding: 0;

    .about {
      width: 95%;
      margin: 0 auto;
      padding-top: 28px;
      flex-direction: column;
      row-gap: 30px;

      & > .content {
        & > .title {
          text-align: center;
          font-size: 28px;
        }

        & > .desc {
          text-align: center;
          font-size: 18px;
        }
      }

      & > .img {
        width: calc(100% - 34px);
      }
    }

    .who {
      width: 100%;
      margin-top: 120px;

      & > .who-wrapper {
        width: 95%;
        margin: 0 auto;
        padding: 46px 0;
        flex-direction: column;

        & > .img {
          width: 100%;
          align-items: flex-start;
          justify-content: space-between;

          & > img {
            &:nth-of-type(1) {
              flex: 1;
              min-width: 0;
              height: auto;
            }
            &:nth-of-type(2) {
              flex: 1;
              min-width: 0;
              height: auto;
            }
          }

          &:hover {
            & > img:nth-of-type(1) {
              transform: translateY(36px);
            }
            & > img:nth-of-type(2) {
              transform: translateY(-12px);
            }
          }
        }

        & > .content {
          & > .title {
            text-align: center;
            font-size: 28px;
          }

          & > .desc {
            text-align: center;
            font-size: 18px;
          }
        }
      }
    }

    .why {
      width: 95%;
      margin: 0 auto;
      padding: 46px 0px;

      & > .title {
        width: 95%;
        margin: 0 auto;
        font-size: 28px;
      }

      & > .carousel {
        margin-top: 56px;
        box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
        height: 650px;
        margin-bottom: 56px;

        .carousel-inner {
          height: 650px;

          .carousel-item {
            flex-direction: column;
            padding: 24px;
            border-radius: 30px;
            row-gap: 12px;
            height: 550px;
            box-shadow: 0 0px 10px 0px rgba(0, 0, 0, 0.3);
            justify-content: space-between;
            transform: translateY(450px);
            transition: all 1s ease-in-out;

            &.active {
              transform: translateY(0px);
            }

            & > .content {
              row-gap: 8px;
              flex: auto;

              & > .title {
                font-size: 22px;
                width: 100%;
                text-align: center;
              }
              & > .content {
                font-size: 16px;
                text-align: center;
              }
            }

            & > .img {
              width: 100%;
              height: auto;

              & > img {
                width: 100%;
                height: auto;
                border-radius: 20px;
              }
            }

            & > .index-bg {
              left: 0;
              top: 0;
              transform: translate(-200px, 0);
            }
          }
        }

        .indicator {
          left: 50%;
          transform: translateX(-50%);
          flex-direction: row;
          bottom: -50px;
          top: auto;
          column-gap: 16px;
          justify-content: center;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave {
  opacity: 1;
}
</style>
